import { render } from "./ShelfTemplateAdminProduct.vue?vue&type=template&id=4ffb80c9&scoped=true"
import script from "./ShelfTemplateAdminProduct.vue?vue&type=script&lang=js"
export * from "./ShelfTemplateAdminProduct.vue?vue&type=script&lang=js"

import "./ShelfTemplateAdminProduct.vue?vue&type=style&index=0&id=4ffb80c9&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffb80c9"]])

export default __exports__